// extracted by mini-css-extract-plugin
export var form = "NewsletterSignup-module--form--rLpfF";